// iOS-specific PWA fixes and enhancements

export function initializeIosSupport(): void {
    // Prevent bounce/overscroll on iOS
    document.addEventListener('touchmove', (e: TouchEvent) => {
        const target = e.target as Element;
        if (target.closest('.overflow-y-auto, .overflow-x-auto, .overflow-auto')) {
            return;
        }
    }, { passive: true });

    // iOS standalone mode: Only intercept EXTERNAL links to prevent Safari from opening them.
    // Internal links are handled by Blazor's router via the History API - do not interfere.
    const nav = window.navigator as Navigator & { standalone?: boolean };
    if (nav.standalone) {
        document.addEventListener('click', (e: MouseEvent) => {
            const target = e.target as Element;
            const link = target.closest('a') as HTMLAnchorElement | null;
            if (link && link.href) {
                const url = new URL(link.href);
                // Only handle external links - let Blazor handle internal navigation
                if (url.origin !== location.origin) {
                    // External link: open in Safari (default iOS behavior)
                    // or could use window.open(link.href, '_blank') to control behavior
                    return;
                }
                // Internal links: do nothing, let Blazor's NavigationManager handle it
            }
        });
    }
}
